export enum CustomFieldType{
    Number = 1,
    SingleSelect = 2,
    MultiSelect = 3
}